import { TemplateConfigurations } from '@/constants/templateConfig';
import { TemplateType } from '@/types/boot';

export type Viewport = 'mobile' | 'desktop';

/** Supercell embedded shell: plain summary card, publisher font, content-sized iframe. */
export const isEmbeddedTemplateType = (templateType: TemplateType | undefined): boolean =>
  templateType === TemplateType.EMBEDDED_VIEW || templateType === TemplateType.EMBEDDED_PREFERRED_PAYMENT_METHOD;

/**
 * Whether the template allows the publisher hero background to paint at the
 * given viewport. When `viewport` is omitted, returns true if EITHER viewport
 * allows the background — handy for "is this template ever a BG template"
 * checks that don't care about the current device width.
 */
export const isTemplateSupportBG = (templateType: TemplateType, viewport?: Viewport): boolean => {
  const template = TemplateConfigurations[templateType];
  if (!template) return false;
  const { showBackground } = template;
  if (viewport) return showBackground[viewport];
  return showBackground.mobile || showBackground.desktop;
};

// Removed `getDefaultPaymentMethodSelected` — was a pre-template-class
// utility that switched on `template.type` (which the architecture
// explicitly forbids leaves from doing — see CheckoutTemplate docstring).
// Default-method selection now lives on each template class:
//   - DefaultTemplate.resolveDefaultPaymentMethod          → first non-express
//   - SinglePaymentTemplate.resolveDefaultPaymentMethod    → paymentMethods[0]
//   - PreferredPaymentTemplate.resolveDefaultPaymentMethod → device express
//     wallet (FTD branch) OR boot's preferredPaymentMethod (last-method branch)
// Callers should invoke `activeTemplate.resolveDefaultPaymentMethod(...)`
// (see CheckoutContent.tsx).
